import WalletAddMember from "./WalletAddMember";

export default WalletAddMember;
